<template>
    <div class="bg-white p-6 shadow-md rounded-xl">
        <h2 class="text-lg font-semibold text-gray-700 mb-4 flex items-center">
            <span class="mr-2">🏢</span>
            <span>Engagements by Entity</span>
        </h2>
        <apexchart type="bar" height="300" :options="chartOptions" :series="chartSeries" />
    </div>
</template>

<script>
export default {
    name: "EngagementsByEntityChart",
    props: {
        data: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        chartOptions() {
            return {
                chart: {
                    type: 'bar',
                    toolbar: { show: false },
                    events: {
                        dataPointSelection: (event, chartContext, config) => {
                            const selectedEntity = chartContext.w.config.xaxis.categories[config.dataPointIndex];
                            if (selectedEntity) {
                                this.onEntityBarClick(selectedEntity);
                            }
                        },
                    },
                },
                xaxis: {
                    categories: this.data.map(item => this.formatEntityName(item.entity)),
                    title: {
                        text: 'Entity',
                        style: {
                            fontSize: '12px',
                            fontWeight: 'bold',
                        },
                    },
                },
                yaxis: {
                    title: {
                        text: 'Number of Engagements',
                        style: {
                            fontSize: '12px',
                            fontWeight: 'bold',
                        },
                    },
                },
                colors: this.getPowerBIColors(),
                plotOptions: {
                    bar: {
                        borderRadius: 0,
                        columnWidth: "60%",
                        distributed: true,
                    },
                },
                dataLabels: {
                    enabled: true,
                    formatter: function (val) {
                        return val;
                    },
                },
                tooltip: {
                    y: {
                        formatter: (val) => `${val} engagements`,
                    },
                },
                legend: {
                    show: false
                }
            };
        },
        chartSeries() {
            return [
                {
                    name: "Engagements",
                    data: this.data.map(item => item.count)
                }
            ];
        }
    },
    methods: {
        onEntityBarClick(entity) {
            this.$emit('entity-clicked', this.unFormatEntityName(entity));
        },
        formatEntityName(entity) {
            return entity.replace(/ATHS/g, "ATS");
        },
        unFormatEntityName(entity) {
            return entity.replace(/ATS/g, "ATHS");
        },
        getPowerBIColors() {
            // Power BI inspired color palette
            return [
                '#1f77b4', // Blue
                '#ff7f0e', // Orange
                '#2ca02c', // Green
                '#d62728', // Red
                '#9467bd', // Purple
                '#8c564b', // Brown
                '#e377c2', // Pink
                '#7f7f7f', // Gray
                '#bcbd22', // Olive
                '#17becf', // Cyan
                '#aec7e8', // Light Blue
                '#ffbb78', // Light Orange
                '#98df8a', // Light Green
                '#ff9896', // Light Red
                '#c5b0d5', // Light Purple
                '#c49c94', // Light Brown
                '#f7b6d3', // Light Pink
                '#c7c7c7', // Light Gray
                '#dbdb8d', // Light Olive
                '#9edae5'  // Light Cyan
            ];
        }
    }
};
</script>
